<template>
  <div class="ran_mian">
    <h2>3、个人考试排名</h2>
    <p>
      全院共<span>{{ $parent.threeData.length }}</span
      >人参考，按"最终成绩和"用时"依次综合排名前10如下：
    </p>
    <div class="ran_table">
      <p>科室考试排名{{$parent.rolling}}</p>
      <div class="select_view">
        <p>分页选择：</p>
        <el-select v-model="paging" placeholder="请选择" @change="changPaging">
          <el-option
            v-for="item in pagingArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="table">
        <el-table
          :data="ranData"
          border
          style="width: 100%"
          :height="$parent.rolling == true ? 541 : ''"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
            'text-align': 'center',
          }"
        >
          <el-table-column label="排名" type="index" width="100">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ranData: [],
      paging: "null",
      pagingArr: [
        {
          value: "null",
          label: "全部",
        },
        {
          value: "10",
          label: "10",
        },
        {
          value: "20",
          label: "20",
        },
        {
          value: "50",
          label: "50",
        },
      ],
      formColumns: [
        {
          prop: "RealName",
          label: "姓名",
        },
        {
          prop: "DepartmentName",
          label: "科室",
        },
        {
          prop: "examTime",
          label: "用时(分钟)",
        },
        {
          prop: "Score",
          label: "最终成绩(分)",
        },
      ],
    };
  },
  methods: {
    fn() {
      this.$parent.rolling = !this.$parent.rolling;
      console.log(this.$parent.rolling);
    },
    // 分页展示
    changPaging(a) {
      if (a == "null") {
        this.ranData = this.$parent.threeData;
        console.log(this.ranData, "默认执行了");
      } else {
        this.ranData = this.$parent.threeData.slice(0, a);
      }
      console.log(a);
    },
  },
};
</script>

<style lang="scss" scoped>
.ran_mian {
  p {
    margin-top: 16px;
    letter-spacing: 2px;
    span {
      color: red;
    }
  }
  .ran_table {
    p {
      text-align: center;
    }
  }
  .table {
    padding: 0 300px;
  }
  .el-table {
    margin-top: 20px;
  }
}
::v-deep .el-table th.el-table__cell > .cell {
  text-align: center;
}
::v-deep .el-table td.el-table__cell div {
  text-align: center;
}
::v-deep .el-table .cell {
  text-align: center;
  // margin-bottom: ;
}
.select_view {
  display: flex;
  align-items: center;
  p {
    margin: 0 !important;
  }
}
</style>